/**
 * Tracks whether the current user is mid-workout (timer actively running).
 * Read by IncomingCallContext to auto-decline incoming buddy live calls so
 * users don't get interrupted while training. WorkoutDetailPage is the only
 * writer — it pushes the flag whenever its `isRunning` state changes.
 */
import { createContext, useCallback, useContext, useState } from 'react';

const WorkoutStatusContext = createContext({ isWorkoutActive: false });

export function WorkoutStatusProvider({ children }) {
  const [isWorkoutActive, setIsWorkoutActive] = useState(false);
  const setActive = useCallback((next) => setIsWorkoutActive(!!next), []);
  return (
    <WorkoutStatusContext.Provider value={{ isWorkoutActive, setIsWorkoutActive: setActive }}>
      {children}
    </WorkoutStatusContext.Provider>
  );
}

export function useWorkoutStatus() {
  return useContext(WorkoutStatusContext);
}
